<template>
  <div id="Home">
    <section class="hero">
      <div class="container">
        <span class="eyebrow">Ten Factor Growth</span>
        <h1>Executive experience for growing technology companies.</h1>
        <p class="lede">Since 2017, Ten Factor Growth has helped technology
          companies accelerate their growth and potential for success. I provide
          consulting on technology strategy, architecture, product management,
          and operational growth.</p>
        <div class="btn-row">
          <router-link to="/contact" class="btn light">Get in touch</router-link>
          <router-link to="/services" class="btn ghost">See services</router-link>
        </div>
      </div>
    </section>

    <section class="proof">
      <div class="container">
        <span class="label">Worked with</span>
        <span class="name" v-for="n in clients" :key="n">{{ n }}</span>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="section-head center">
          <span class="eyebrow">Services</span>
          <h2>CTO advising</h2>
        </div>
        <div class="grid cols-3">
          <router-link v-for="(s, i) in services" :key="s.title" to="/services" class="card">
            <div class="num">{{ i + 1 }}</div>
            <h3>{{ s.title }}</h3>
            <p>{{ s.text }}</p>
            <span class="more">Learn more &rarr;</span>
          </router-link>
        </div>
      </div>
    </section>

    <section class="section tint">
      <div class="container">
        <div class="card prose" style="margin:0 auto">
          <h3>Growing your startup</h3>
          <p>You have a passion to drive your company to the next level, but
            you need executive management and advice on key decisions. I have
            been there.</p>
          <p>I have decades of start-up experience over several dozen startups
            in all top executive roles: CEO, COO, and CTO. I can fill in your
            gaps, deliver on key initiatives, and help build the team.</p>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="section-head">
          <span class="eyebrow">Industry experience</span>
          <h2>Companies across technology</h2>
          <p class="lede">I have worked with companies in marketing tech, health
            tech, education tech, robotics, consumer hardware, and enterprise. I
            can advise you on positioning and alignment for a successful exit.</p>
        </div>
        <div class="grid cols-3">
          <router-link v-for="i in industries" :key="i.path" :to="i.path" class="card">
            <h3>{{ i.menu }}</h3>
            <p>{{ i.lede }}</p>
            <span class="more">See customers &rarr;</span>
          </router-link>
        </div>
      </div>
    </section>

    <section class="cta">
      <div class="container">
        <h2>Let&rsquo;s talk about your next stage of growth.</h2>
        <p>Tell me where you are and where you want to be.</p>
        <router-link to="/contact" class="btn light">Contact us</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import industries from '@/data/industries'

export default {
    name: 'Home',
    title: 'Home - Ten Factor Growth',
    data() {
        return {
            industries,
            clients: ['Jibo', 'Pillo Health', 'EnglishCentral', 'Nuance', 'Nanigans', 'Course Advisor'],
            services: [
                { title: 'Technology & Data',
                  text: 'Companies\' technology and data strategies evolve as they grow. I can help you get the right level in place for each stage.' },
                { title: 'AI-First Organization',
                  text: 'Move from AI in engineering to AI across the teams that deliver your product, one incremental step at a time.' },
                { title: 'Product & Operations',
                  text: 'Hitting speed bumps in your technology or product? I can help align your product definition, development process, and team.' }
            ]
        }
    },
    mounted() {
        this.$analytics.logEvent('Home')
    }
}
</script>
